// extracted by mini-css-extract-plugin
module.exports = {"proteinMarkpen":"RecommendedMedical_proteinMarkpen__7n4l9","proteinDoctor":"RecommendedMedical_proteinDoctor__ig30l"};